import { compose } from 'ramda';
import { withProps } from 'recompose';

import connect from 'app/libs/connect';
import S from 'app/features/newLanding/components/newProductComparison/Product/Product.styled';
import {
  productOrderMobile,
  productOrderIpad,
  productOrderDesktop,
} from 'app/features/products/selectors';

const state = {
  mobileOrder: productOrderMobile,
  tabletOrder: productOrderIpad,
  desktopOrder: productOrderDesktop,
};

const ProductWrapper = compose(
  connect(state),
  withProps({ 'data-t': 'product' }),
)(S.Product);

export default ProductWrapper;
